export default {
  metaDescription: 'Read the full article from PT Tokki Engineering and Fabrication (TEF), covering company news, project milestones and industry insights.',
  pageTitle: 'Detail News & Blog',
  backToList: 'Back to News & Blog',
  sidebar: {
    title: 'News & Other Blogs',
  },
};
